import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Stack,
} from "@mui/material";
import { BsPencilSquare } from "react-icons/bs";
import {
  GetAllAdminDetails,
  GetAnalyticsbyType,
  getcandidateDetails,
  getCandidateLead,
} from "../../../../apiServices";
import { useSelector } from "react-redux";
import { AiOutlineClose } from "react-icons/ai";
import style from "../../../AdminDetails/ConfigarationTablesCrud/JobRoleDetails/jobRolesTable.module.scss";
import interviewStyle from "../../../Candidate/Candidate interview schedule list/candidateInterviewSchedule.module.scss";
import { useDispatch } from "react-redux";
import {
  AdminAnalyticsActions,
  commonPopupActions,
} from "../../../../redux-store/store";
import { dateFormateDD, textTruncate } from "../../../../utility";
import AdminTableFilter from "./AdminTableFilter";

function AdminAnalyticsCandidateTableView({ onclose }) {
  const adminAnalyticsFilter = useSelector(
    (state) => state.AdminAnalytics.typeAnalyticsFilter
  );
  const adminAnalyticsFilterType = useSelector(
    (state) => state.AdminAnalytics.typeAnalyticsFilter.type
  );
  const adminDetails = useSelector((state) => state.adminDetails);

  let isSuperAdmin = adminDetails.roleID == 1;

  const [analyticsData, setAnalyticsData] = useState([]);
  const [data, setData] = useState();
  const [adminList, setAdminList] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setcurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const Dispatch = useDispatch();

  const handleCandidateDetails = async (candidateId, type) => {
    let data;
    if (type === "RegisterCandidate") {
      data = await getcandidateDetails(candidateId);
    } else if (type === "CandidateLead") {
      data = await getCandidateLead(candidateId);
    }

    Dispatch(
      commonPopupActions.setShowPopup({
        name: "candidateDetails",
        id: candidateId,
        type: type,
        data: data,
      })
    );
  };
  useEffect(() => {}, [adminAnalyticsFilter]);
  useEffect(() => {
    GetAnalyticsbyType(adminAnalyticsFilter)
      .then((data) => {
        setAnalyticsData(data?.results || []);
        setTotalPages(data?.totalPages || 1);
        setcurrentPage(data?.currentPage || 0);
        setTotalRecords(data?.totalRecords || 0);
      })
      .catch(() => setAnalyticsData([]));
    GetAllAdminDetails()
      .then((admins) => {
        const filtered = admins.filter(
          (admin) => !admin.Deactived && admin.Module !== "Developer"
        );
        setAdminList(filtered);
      })
      .catch(() => alert("Something went wrong"));
  }, [adminAnalyticsFilter]);

  const getAdminUsername = (adminId) => {
    if (!Array.isArray(adminList)) return "Taizo";
    const admin = adminList.find((a) => a.id === adminId);
    return admin?.userName || "Taizo";
  };

  function candidatePagination(event, page) {
    const currentPage = page - 1;

    Dispatch(AdminAnalyticsActions.settypeAnalyticsPage(currentPage));
  }
  const filterTypeLabels = {
    interviewScheduledByAdmin: "Interview Scheduled",
    interviews: "Interviews",
    interviewAttended: "Interview Attended",
    selected: "Selected",
    joined: "Joined",
    registeredCount: "Registered",
    leadNotRegistredCount: "Leads Not Registered",
    leadRegisteredCount: "Leads Registered",
    totalLead: "Total Leads",
  };
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div>
          <b>{filterTypeLabels[adminAnalyticsFilterType] || "Unknown Type"}</b>{" "}
          ({totalRecords})
        </div>
        <div className="d-flex align-items-center  gap-2">
          <div className="">
            <AdminTableFilter />
          </div>

          <div onClick={() => onclose()} className="btn btn-danger ">
            <AiOutlineClose />
          </div>
        </div>
      </div>
      <TableContainer
        style={{ height: "62vh", width: "86vw", overflow: "auto" }}
      >
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {[
                "Candidate Name",
                "Mobile Number",
                "Job Category",
                "From Source",
                // "Experience",
                "Preferred Location",
                ...(isSuperAdmin ? ["Recruiter Name"] : []),
                "Created On",
                "Current Status",
              ].map((title, i) => (
                <TableCell
                  key={i}
                  sx={{ backgroundColor: "#169c50", color: "#fff" }}
                >
                  <strong>{title}</strong>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {analyticsData.length > 0 ? (
              analyticsData.map((row, index) => (
                <TableRow
                  key={row.id}
                  className={style["table-row"]}
                  onClick={() => setData(row)}
                >
                  {/* <TableCell sx={{ padding: "10px 12px" }}>
                    {(mothlyTargetFilter.page - 1) * 10 + index + 1}
                  </TableCell> */}
                  <TableCell
                    onClick={() => {
                      adminAnalyticsFilterType === "leadRegisteredCount" ||
                      adminAnalyticsFilterType === "registeredCount"
                        ? handleCandidateDetails(
                            row.candidate_id,
                            "RegisterCandidate"
                          )
                        : handleCandidateDetails(row.id, "CandidateLead");
                    }}
                    style={{ cursor: "pointer" }}
                    className="text-primary "
                    title={row.first_name + " " + row.last_name}
                  >
                    {row.first_name != null
                      ? textTruncate(row.first_name, 15) + " " + row.last_name
                      : "No Name"}
                  </TableCell>
                  <TableCell>{row.mobile_number}</TableCell>
                  <TableCell>
                    {row.job_category != null
                      ? textTruncate(row.job_category, 15)
                      : "-"}
                    {/* {row.job_category} */}
                  </TableCell>
                  <TableCell>
                    {row.from_source != null
                      ? textTruncate(row.from_source, 15)
                      : "-"}
                  </TableCell>
                  {/* <TableCell>
                    {adminAnalyticsFilterType === "leadRegisteredCount" ||
                    adminAnalyticsFilterType === "registeredCount"
                      ? row.exp_in_years != 0
                        ? row.exp_in_years
                        : row.exp_in_years === 0 && row.exp_in_months === 0
                        ? "Fresher"
                        : "0"
                      : row.experienced === 0
                      ? "Fresher"
                      : "Expereince"}
                  </TableCell> */}

                  <TableCell title={row.pref_location}>
                    {row.pref_location != null
                      ? textTruncate(row.pref_location, 15)
                      : "-"}
                  </TableCell>

                  {isSuperAdmin && (
                    <TableCell>{getAdminUsername(row.assign_to)}</TableCell>
                  )}
                  <TableCell>{dateFormateDD(row.created_time)}</TableCell>
                  <TableCell title={row.pipeline_stage}>
                    {row.pipeline_stage != null
                      ? textTruncate(row.pipeline_stage, 15)
                      : "-"}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={8}
                  align="center"
                  sx={{
                    height: "60vh",
                    verticalAlign: "middle",
                    fontWeight: 500,
                    color: "#666",
                  }}
                >
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <div
      // style={{
      //   position: "fixed",
      //   bottom: 0,
      //   left: 0,
      //   width: "100%",
      //   backgroundColor: "#fff",
      //   padding: "10px 0",
      //   boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
      //   zIndex: 10,
      // }}
      >
        <Stack direction="row" justifyContent="center">
          <Pagination
            // count={10}
            shape="rounded"
            siblingCount={1}
            boundaryCount={1}
            count={totalPages}
            // variant="outlined"
            color="success"
            onChange={candidatePagination}
          />
        </Stack>
      </div>
    </>
  );
}

export default AdminAnalyticsCandidateTableView;
